package com.qrkontaq.ui.sections.header

import androidx.compose.runtime.Composable
import com.qrkontaq.ui.sections.header.components.MenuItems

@Composable
internal fun NavHeaderDesktop() {
    MenuItems()
}
